// extracted by mini-css-extract-plugin
module.exports = {"search-form":"K_dr flex-grow-1 form-group mb-0"};